export const waitForElementById = (
  id: string,
  timeoutMs = 6000,
): Promise<HTMLElement> => {
  return new Promise((resolve, reject) => {
    const existing = document.getElementById(id);
    if (existing) {
      resolve(existing);
      return;
    }

    let settled = false;

    const observer = new MutationObserver(() => {
      const el = document.getElementById(id);
      if (el && !settled) {
        settled = true;
        observer.disconnect();
        clearTimeout(timer);
        resolve(el);
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    const timer = setTimeout(() => {
      if (!settled) {
        settled = true;
        observer.disconnect();
        reject(
          new Error(
            `waitForElementById(#${id}) timed out after ${timeoutMs}ms`,
          ),
        );
      }
    }, timeoutMs);
  });
};
